angular.module('impactx.productview').controller('ProductViewListCtrl', [
    'ConfirmationService',
    'ToastService',
    'TranslationService',
    'dataGen',
    '$redirect',
    'selectedListItems',
    ProductViewListCtrl
]);

function ProductViewListCtrl(ConfirmationService, ToastService, TranslationService, dataGen, $redirect, selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ListProductView'
        },
        {
            label: "delete",
            action: deleteProductView,
            condition: selectedListItems.isMultiSelection,
            process: 'ViewProductView'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/productview/templates/productviewlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/productview/list',
        id: "productviewlist",
        mainAction: {id: "new", link: "#/productview/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function deleteProductView() {
        var productViewIds = selectedListItems.getSelectedIds('id');
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {ids: productViewIds}, "/productview/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                $redirect.reload();
            });
        }, undefined, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    function getDetailLink() {
        return "productview/" + selectedListItems.getFirstSelectedId() + "/1";
    }
}